const Bills = () => import("Modules/supply_chain/bills/views/Bills");
const BillsForm = () => import("Modules/supply_chain/bills/views/BillsForm");

export default {
    children: [
        {
            path: "purchasing/bills",
            name: "bills",
            component: Bills,
            meta: {
                requiresAuth: true,
                title: "lang.bills",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["bills.read"],
            },
        },
        {
            path: "purchasing/bill/:id?",
            name: "bill",
            component: BillsForm,
            meta: {
                requiresAuth: true,
                title: "lang.bills",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["bills.read"],
            },
        },
    ],
};
